import { render, staticRenderFns } from "./classes-begin.vue?vue&type=template&id=1719187a&scoped=true"
import script from "./classes-begin.vue?vue&type=script&lang=js"
export * from "./classes-begin.vue?vue&type=script&lang=js"
import style0 from "./classes-begin.vue?vue&type=style&index=0&id=1719187a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1719187a",
  null
  
)

export default component.exports